var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "panel panel-plain",
      class: _vm.panelClass,
      attrs: { id: _vm.id }
    },
    [
      _c("div", { staticClass: "panel-heading" }, [
        _vm.headingLevel === 2
          ? _c(
              "h2",
              { staticClass: "panel-title" },
              [
                _vm.titleAsLink
                  ? [
                      !!_vm.iconClass
                        ? _c("font-awesome-icon", {
                            attrs: { icon: _vm.iconClass }
                          })
                        : _vm._e(),
                      _c(
                        "router-link",
                        { attrs: { to: _vm.panelLinkAddress } },
                        [_vm._v(" " + _vm._s(_vm.title))]
                      )
                    ]
                  : [
                      !!_vm.iconClass
                        ? _c("font-awesome-icon", {
                            attrs: { icon: _vm.iconClass }
                          })
                        : _vm._e(),
                      _vm._v(" " + _vm._s(_vm.title) + "\n\t\t\t")
                    ]
              ],
              2
            )
          : _vm.headingLevel === 3
          ? _c(
              "h3",
              { staticClass: "panel-title" },
              [
                !!_vm.iconClass
                  ? _c("font-awesome-icon", { attrs: { icon: _vm.iconClass } })
                  : _vm._e(),
                _vm._v(" " + _vm._s(_vm.title) + "\n\t\t")
              ],
              1
            )
          : _c(
              "h4",
              { staticClass: "panel-title" },
              [
                !!_vm.iconClass
                  ? _c("font-awesome-icon", { attrs: { icon: _vm.iconClass } })
                  : _vm._e(),
                _vm._v(" " + _vm._s(_vm.title) + "\n\t\t")
              ],
              1
            ),
        _vm._v(" "),
        _vm.buttonIsVisible
          ? _c(
              "button",
              {
                staticClass: "label label-default",
                on: {
                  click: function($event) {
                    return _vm.clearButton()
                  }
                }
              },
              [_vm._v("\n\t\t\t" + _vm._s(_vm.buttonTitle) + "\n\t\t")]
            )
          : _vm._e()
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "panel-body", attrs: { id: "panel-body-" + this.id } },
        [_vm._t("default")],
        2
      ),
      _vm._v(" "),
      _vm.showFooter
        ? _c(
            "div",
            { staticClass: "panel-footer" },
            [_vm._t("panel-footer")],
            2
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }